import { AmlFlowEnum, RiskScoreLevelEnum } from '@/api';
import { IndicatorLite, IndicatorBinary } from './components';

interface RiskIndicatorLimitedProps {
  isChecking?: boolean;
  value: RiskScoreLevelEnum | null;
  className?: string;
  amlFlow: AmlFlowEnum;
}

const RiskIndicatorLimited = ({
  isChecking,
  value,
  className,
  amlFlow,
}: RiskIndicatorLimitedProps) => {
  if (value && amlFlow !== AmlFlowEnum.LITE) {
    return <IndicatorBinary value={value} className={className} />;
  }

  return (
    <IndicatorLite
      isChecking={isChecking}
      value={value}
      className={className}
    />
  );
};

export default RiskIndicatorLimited;
